var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUniversityGeneralTrain(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41.296,
    height: 51.386,
    viewBox: "0 0 41.296 51.386",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "train",
    transform: "translate(-6.08 -3.565)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55375",
    "data-name": "Path 55375",
    d: "M169.728,418.83l.868-1.054h16.991l.868,1.054Z",
    transform: "translate(-152.364 -373.052)",
    fill: "#bac6d0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_48158",
    "data-name": "Group 48158",
    transform: "translate(11.887 46.798)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55376",
    "data-name": "Path 55376",
    d: "M150.208,438.433l1.278-1.553h20.409l1.278,1.553Z",
    transform: "translate(-146.849 -436.88)",
    fill: "#63c5b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55377",
    "data-name": "Path 55377",
    d: "M119.264,468.127l2.068-2.511h25.544l2.07,2.511Z",
    transform: "translate(-119.264 -462.497)",
    fill: "#63c5b7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_48159",
    "data-name": "Group 48159",
    transform: "translate(6.08 44.047)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55378",
    "data-name": "Path 55378",
    d: "M73.217,422.44H65.76l10.961-10.9h3.5Z",
    transform: "translate(-65.76 -411.536)",
    fill: "#aee0d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55379",
    "data-name": "Path 55379",
    d: "M327.469,422.44h-7.457l-7-10.9h3.5Z",
    transform: "translate(-286.172 -411.536)",
    fill: "#aee0d9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_48160",
    "data-name": "Group 48160",
    transform: "translate(9.327 3.565)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55380",
    "data-name": "Path 55380",
    d: "M124.532,392.9h-22.9L95.68,388.7h34.8Z",
    transform: "translate(-95.68 -350.7)",
    fill: "#aee0d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55381",
    "data-name": "Path 55381",
    d: "M124.1,40.842a2.55,2.55,0,0,0-2.532-2.282H104.589a2.552,2.552,0,0,0-2.532,2.282A8.418,8.418,0,0,0,95.68,49v27.56h34.8V49A8.419,8.419,0,0,0,124.1,40.842Z",
    transform: "translate(-95.68 -38.56)",
    fill: "#63c5b7"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_55382",
    "data-name": "Path 55382",
    d: "M132.08,136.143v10.411a3.1,3.1,0,0,0,3.1,3.1h20.692a3.1,3.1,0,0,0,3.1-3.1V136.143a3.1,3.1,0,0,0-3.1-3.1h-20.69A3.106,3.106,0,0,0,132.08,136.143Z",
    transform: "translate(-118.802 -119.22)",
    fill: "#dff9ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_48161",
    "data-name": "Group 48161",
    transform: "translate(13.28 13.818)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55383",
    "data-name": "Path 55383",
    d: "M142.771,133.026,132.1,143.7v2.838a3.081,3.081,0,0,0,.491,1.664l15.178-15.178h-4.994Z",
    transform: "translate(-132.096 -133.024)",
    fill: "#aee0d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55384",
    "data-name": "Path 55384",
    d: "M157.323,133.04l-15.8,15.8a3.078,3.078,0,0,0,1.177.665l16.468-16.468Z",
    transform: "translate(-140.497 -133.038)",
    fill: "#aee0d9"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_55385",
    "data-name": "Path 55385",
    d: "M149.3,143.886H128.61a3.91,3.91,0,0,1-3.906-3.906V129.57a3.909,3.909,0,0,1,3.906-3.906H149.3a3.91,3.91,0,0,1,3.906,3.906v10.411A3.911,3.911,0,0,1,149.3,143.886Zm-20.69-16.618a2.3,2.3,0,0,0-2.3,2.3v10.411a2.3,2.3,0,0,0,2.3,2.3H149.3a2.3,2.3,0,0,0,2.3-2.3V129.57a2.3,2.3,0,0,0-2.3-2.3Z",
    transform: "translate(-112.226 -112.645)",
    fill: "#387f75"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_48162",
    "data-name": "Group 48162",
    transform: "translate(15.465 5.064)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55386",
    "data-name": "Path 55386",
    d: "M166.544,54.742h0a2.439,2.439,0,0,0,2.5,2.374h14.421a2.439,2.439,0,0,0,2.5-2.374h0a2.439,2.439,0,0,0-2.5-2.374H169.043A2.439,2.439,0,0,0,166.544,54.742Z",
    transform: "translate(-164.99 -52.368)",
    fill: "#dff9ff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2813",
    "data-name": "Ellipse 2813",
    cx: 3.119,
    cy: 3.119,
    r: 3.119,
    transform: "translate(16.289 28.095)",
    fill: "#dff9ff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2814",
    "data-name": "Ellipse 2814",
    cx: 3.119,
    cy: 3.119,
    r: 3.119,
    transform: "translate(0 28.095)",
    fill: "#dff9ff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_55387",
    "data-name": "Path 55387",
    d: "M112.826,377.456H76.906a1.658,1.658,0,0,0-1.658,1.658h0a1.659,1.659,0,0,0,1.658,1.658h35.92a1.658,1.658,0,0,0,1.658-1.658h0A1.658,1.658,0,0,0,112.826,377.456Z",
    transform: "translate(-68.138 -337.108)",
    fill: "#387f75"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUniversityGeneralTrain);
export default __webpack_public_path__ + "static/media/university-general-train.022539a63508dc54fede9acfc13475e4.svg";
export { ForwardRef as ReactComponent };